<template>
    <form-row title="Has the Zoning Change Been Applied For?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="zoning_change_applied_for"
                v-model="zoning_change_applied_for"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="zoning_change_applied_for"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Applied:"
                :value="commercial.zoning_change_applied_for_date"
                name="zoning_change_applied_for_date"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            zoning_change_applied_for: this.commercial.zoning_change_applied_for,
        }
    },
}
</script>
